<div class="modal-header">
    <h3 class="title">Update Prioritization(s)</h3>
    <aurora-icon-button id="PrioritizationConfirmClose" icon="times" variant="ghost" size="xlarge" aria-label="Close" (click)="activeModal.dismiss()"></aurora-icon-button>
</div>
<div class="modal-body">
    <div class="mb-3">
        The changes below will impact the current prioritization order in which the {{ "Accounts" | smNomenclatureByRegion | async }} are displayed in 'My Work':
    </div>
    <div *ngIf="orderChanges.length != 0" class="mb-3">
        <div class="fw-bold">
            Prioritization Order changes:
        </div>
        <ul id="orderChanges">
            <li *ngFor="let orderChange of orderChanges">
                {{ orderChange.Type }} moved from position {{ orderChange.PriorityBefore }}
                 to position {{ orderChange.PriorityAfter }}
            </li>
        </ul>
    </div>
    <div *ngIf="timerChanges.length != 0">
        <div class="fw-bold">
            Default Increment Timers switch from Pending to Imminent:
        </div>
        <ul id="timerChanges">
            <li *ngFor="let timerChange of timerChanges">
                <ng-container *ngIf="timerChange.UnitsBefore == timerChange.UnitsAfter">
                    {{ timerChange.Type }} was changed from {{ timerChange.AmountBefore }}
                     to {{ timerChange.AmountAfter }} {{ timerChange.UnitsBefore }}
                </ng-container>
                <ng-container *ngIf="timerChange.UnitsBefore != timerChange.UnitsAfter">
                    {{ timerChange.Type }} was changed from {{ timerChange.AmountBefore }} {{ timerChange.UnitsBefore }}
                     to {{ timerChange.AmountAfter }} {{ timerChange.UnitsAfter }}
                </ng-container>
            </li>
        </ul>
    </div>
</div>
<div class="modal-footer">
    <div class="actions">
        <aurora-button variant="primary" type="button" id="PrioritizationConfirmButton" (click)="confirm()">
            <span class="label">Update</span>
        </aurora-button>
        <aurora-button variant="ghost" type="button" (click)="activeModal.dismiss()">
            <span class="label">Cancel</span>
        </aurora-button>
    </div>
</div>